<script setup lang="ts">
import type { QTableProps } from 'quasar';
import { mdiAlert } from '@quasar/extras/mdi-v7';
import type { Plan } from '../../views/SettingBillingView/usePlan';

interface Props {
  plans: Plan[];
  columns: QTableProps['columns'];
}

defineProps<Props>();

// Compute the active plan from the orders array
</script>

<template>
  <q-table
    :rows="plans"
    :columns="columns"
    hide-header
    hide-bottom
    class="q-mb-xl"
  >
    <template #no-data>
      <div class="full-width row flex-center text-accent q-gutter-sm">
        <q-icon
          size="2em"
          :name="mdiAlert"
        />
        <span>{{ $t('NO_DATA_AVAILIABLE') }}</span>
      </div>
    </template>
  </q-table>
</template>

<style scoped>
td {
  width: 10rem;
  text-align: center;
  border: 1px solid #6a6a6a;
}
</style>
